import { Grid, Typography } from "@mui/material";

import React from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  ArcElement,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  BookingReportOptions,
  BookingReport,
  BookingStatus,
  BookingStatusOptions,
} from "./RideData";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function BookingReportStatus(props) {
  return (
    <Grid item container mt={1} columnSpacing={7} mb={4}>
      <Grid item xs={12} sm={12} md={8}>
        <div className="reportChart">
          <Typography variant="h6" className="fw600" pt={1}>
            {props?.titleData.barTitle}
          </Typography>
          <div className="chartMinHeight">
            <Bar
              id="bookingReportChart"
              options={BookingReportOptions}
              data={BookingReport()}
            />
          </div>
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <div className="reportChart">
          <div className="reportsDatePicker">
            <Typography variant="h6" className="fw600" pt={1}>
              {props?.titleData.doughnutTitle}
            </Typography>
          </div>

          <div className="chartMinHeight">
            <Doughnut
              id="doughnutChart"
              data={BookingStatus}
              options={BookingStatusOptions}
              plugins={[
                {
                  beforeDraw(chart) {
                    const { ctx } = chart;
                    const { top, bottom, left, right } = chart.chartArea;
                    ctx.save();
                    const fontSize = 28;
                    ctx.font = `bolder ${fontSize}px sans-serif`;
                    ctx.textAlign = "center";
                    ctx.textBaseline = "middle";
                    ctx.fillStyle = "#000000";
                    const text = "1000";
                    const textX = Math.round((left + right) / 2);
                    const textY = Math.round((top + bottom) / 2);
                    ctx.fillText(text, textX, textY - 15);

                    ctx.font = `10px sans-serif`;
                    const text2 = "Completed";
                    ctx.fillStyle = "#969696";
                    ctx.fillText(text2, textX, textY + 15);
                  },
                },
              ]}
            />
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
